export const BM_FINANCE_RESET_STATE = "bmFinanceResetState"
export const SET_BM_FINANCES = "setBMFinances"
export const SET_BM_FINANCE = "setBMFinance"
export const SET_BM_FINANCE_PAGINATION = "setBMFinancePagination"